import React from "react";
import {AgGridReact} from "ag-grid-react";
// import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { ModuleRegistry, AllCommunityModule, themeQuartz, colorSchemeDark } from 'ag-grid-community';
ModuleRegistry.registerModules([ AllCommunityModule ]);

export default function GstvAgGrid({data, defs, defaultDef}) {
    if (!data) {
        return null;
    }

    return (
        <div className="gstv-ag-grid">
            <AgGridReact
                theme={themeQuartz.withPart(colorSchemeDark).withParams({
                    backgroundColor: "#1a1a1a",
                })}
                rowData={data}
                columnDefs={defs}
                defaultColDef={defaultDef}
                pagination={true}
            />
        </div>
    );
}
